if (!customElements.get('tab-slider')) {
  class TabSlider extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.swiper-scrollbar',
    };
    settings = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      scrollbar: {
        el: this.selectors.scrollbar,
        draggable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
      },
    };
    slider = undefined;

    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Init.
     *
     * @returns {Void}
     */
    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
    }
  }
  customElements.define('tab-slider', TabSlider);
}
